import { SET_SUBSCRIPTIONS } from "../actions/subscriptionActions";

const initialState = {
    subscriptions: [],
}

export default function SubscriptionReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptions: action.payload,
            };
        
        default:
            return state;
    }
}
